// extracted by mini-css-extract-plugin
export var standaloneTable = "_ex-0";
export var standaloneTableWithBodyFill = "_ex-1";
export var withExtraHeader = "_ex-2";